export const EDITABLE_CARD_FEATURE = 'cal-txp-editableCard';
export const EMAIL_DONATION_FEATURE = 'cal-txp-emailDonation';
export const GRIFFIN_ACTIONS_FEATURE = 'cal-txp-griffin';
export const INFERENCES_DSAT_FEATURE = 'cal-txp-inferencesDSAT';
export const INVOICE_FEATURE = 'cal-txp-invoice';
export const SERVICE_RESERVATION_FEATURE = 'cal-txp-serviceReservation';
